import React from 'react';
import { Avatar, Box, Divider, Typography } from '@mui/material';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';
import { useNavigate, useParams } from 'react-router-dom';

// Components
import { MDialog } from 'common';

const SubscriptionDialog = () => {
  const navigate = useNavigate();
  const { currentAffiliateId, dataCompanyId } = useParams();

  return (
    <MDialog
      header="Swift+ Enrollment Required"
      leftButtonAction={() => navigate(-1)}
      leftButtonText="Back"
      onClose={() => {}}
      open
      rightButtonAction={() => {
        navigate(`/affiliate/${currentAffiliateId}/${dataCompanyId}/swift-plus`);
      }}
      rightButtonText="Learn More"
      slotProps={{
        paper: {
          sx: {
            maxHeight: '95%',
          },
        },
      }}
    >
      <Box>
        <Box display="flex" mb={3}>
          <Avatar
            sx={{
              backgroundColor: 'warning.light',
              height: 24,
              mr: 1,
              width: 24,
            }}
          >
            <PriorityHighRoundedIcon
              sx={{
                color: 'warning.dark',
                fontSize: 16,
              }}
            />
          </Avatar>
          <Typography
            sx={{
              alignSelf: 'center',
              color: 'text.primary',
            }}
            variant="body1"
          >
            Enroll in Swift+ to access and view Rack Wait Times
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box display="flex" flexDirection="column">
        <Typography sx={{ fontWeight: 700, mt: 2, pl: 2 }} variant="body1">
          Swift+ includes:
        </Typography>
        <ul>
          <li>
            <Typography sx={{ fontWeight: 700 }} variant="body1">
              Discounted rates
            </Typography>
          </li>
          <li>
            <Typography sx={{ fontWeight: 700 }} variant="body1">
              Predictable Pricing
            </Typography>
          </li>
          <li>
            <Typography sx={{ fontWeight: 700 }} variant="body1">
              Value added services
            </Typography>
          </li>
          <li>
            <Typography sx={{ fontWeight: 700 }} variant="body1">
              And more
            </Typography>
          </li>
        </ul>
      </Box>
    </MDialog>
  );
};

export default SubscriptionDialog;
